"use strict";

exports.__esModule = true;
exports.UserActionFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _userActionsContext = require("../userActionsContext");
var _excluded = ["config", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows fields to configure a particular user action.
 */
var UserActionFields = exports.UserActionFields = function UserActionFields(props) {
  var config = props.config,
    onChange = props.onChange,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var userActions = _react["default"].useContext(_userActionsContext.UserActionsContext);
  var userAction = userActions.find(function (action) {
    return action.name === config.name;
  });
  if (!userAction || !userAction.components.Fields) {
    return null;
  }
  var Fields = userAction.components.Fields;
  return /*#__PURE__*/_react["default"].createElement(Fields, _extends({
    config: config,
    onChange: onChange
  }, extra));
};